import { CascadingConfig } from './cascading_config';

export default new CascadingConfig('settings');
